import React, { Dispatch, useRef } from "react"
import { get, includes } from "lodash"
import ClassNames from "classnames"

import { Panel } from "./index"
import { BaseTable } from "components/molecules/table"
import { Pagination } from "components/molecules/pagination"
import { tableColumns } from "config/table_columns"
import { APIResponse } from "redux/apis/types"
import { SearchToggle } from "components/molecules/filter/toggleFilter"
import {
  PAGE_NUM,
  STOCK_BENEFIT_CONDITIONS,
  StockBenefitConditionsType,
} from "config/const"
import {
  useBenefitActionType,
  useBenefitStateType,
} from "components/actions/tool"
import store from "redux/store"
import { pageLoad } from "redux/ducks/PageLoad"
import { open_symbol_detail } from "utils/util"

type StockBenefitPanelType = {
  response: APIResponse.Res
  stockBenefitState: useBenefitStateType
  stockBenefitAction: Dispatch<useBenefitActionType>
}
const benefitColumnNum = 7

export const StockBenefitPanel: React.FC<StockBenefitPanelType> = props => {
  const mainContent = useRef<HTMLDivElement>(null)
  const resultList: Array<APIResponse.Res> = get(
    props.response,
    "ResultList",
    []
  )

  const LoadButton = (prop: { name: string }) => (
    <div
      className="btn btn-primary btn-shaped"
      onClick={() => props.stockBenefitAction({ type: "LOAD_BENEFIT" })}
    >
      {prop.name}
    </div>
  )

  return (
    <Panel
      refElm={mainContent}
      title=""
      className="panel-stock-benefit"
      // refresh={() => store.dispatch(pageLoad())}
    >
      <div className="search-toggle-wrapper">
        <div className="search-toggle-col">
          {Object.keys(STOCK_BENEFIT_CONDITIONS).map((key: string, i) => {
            const conditions: StockBenefitConditionsType =
              STOCK_BENEFIT_CONDITIONS[key]
            return (
              <SearchToggle
                key={i}
                title={conditions.name}
                active={includes(
                  props.stockBenefitState.displayToggle,
                  conditions.id
                )}
                onToggle={() => {
                  props.stockBenefitAction({
                    type: "CHANGE_DISPLAY_TOGGLE",
                    toggleId: conditions.id,
                  })
                }}
              >
                <div
                  className={ClassNames(
                    "panel-filter-list-col",
                    {
                      "is-open": includes(
                        props.stockBenefitState.displayToggle,
                        conditions.id
                      ),
                    },
                    "list-" +
                      conditions.type
                        .replace("CHANGE_BENEFIT_", "")
                        .toLowerCase()
                  )}
                >
                  <ul className="filter-control-row panel-filter-check-list">
                    {conditions.list.map((obs, j) => (
                      <li key={j}>
                        <div className="panel-filter-check-secondary">
                          <label className="checkbox-control">
                            <input
                              type="checkbox"
                              onChange={() =>
                                props.stockBenefitAction({
                                  type: conditions.type,
                                  value: obs.id,
                                })
                              }
                              checked={includes(
                                get(props.stockBenefitState, key, []),
                                obs.id
                              )}
                            />
                            <span>{get(obs, "name", "")}</span>
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <LoadButton name="検索" />
                </div>
              </SearchToggle>
            )
          })}
        </div>
        <div className="result-col">
          <BaseTable
            className="table table-list-view table-striped"
            list={tableColumns.tool.benefit}
            data={resultList}
            onClick={(data: object, i: number, cell: object) => {
              //優待内容のカラムは銘柄詳細への遷移は無し
              if (get(cell, "id") === benefitColumnNum) return
              open_symbol_detail({
                Symbol: get(data, "Symbol"),
                Exchange: get(data, "Exchange"),
                SecurityType: 1,
              })
            }}
          />
          <Pagination
            list={resultList}
            current={props.stockBenefitState.page}
            total={get(props.response, "TotalCount", null)}
            page={PAGE_NUM.PAGE_20}
            changePage={(p: number) =>
              props.stockBenefitAction({ type: "CHANGE_BENEFIT_PAGE", page: p })
            }
            scrollUpElement={mainContent.current}
          />
        </div>
      </div>
    </Panel>
  )
}
